module.exports = __webpack_public_path__ + "img/web_morse_2.d0fe0da5.jpg";